import { BASE_API_URL } from 'js/constants/App';

export const getSiteData = () => {
  const url = `${BASE_API_URL}get_data`;
  return fetch(url, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  })
    .then(async (response) => {
      const text = await response.text();
      let parsed;

      try {
        parsed = text ? JSON.parse(text) : {};
      } catch (e) {
        parsed = text;
      }

      if (!response.ok) {
        return {
          result: 'FAILURE',
          reason: parsed?.message || parsed || 'An unknown error occurred.',
        };
      }

      return { result: 'SUCCESS', payload: parsed };
    })
    .catch((error) => {
      return { result: 'FAILURE', reason: error?.message || error };
    });
};
